import { Crosshair, Lightning, ArrowsInLineVertical, TrendUp, ArrowsClockwise, Warning, ClockCounterClockwise } from "@phosphor-icons/react";

const STEPS = [
  { key: "identify", n: 1, title: "Identify", icon: Crosshair, accent: "text-amber-700" },
  { key: "exploit", n: 2, title: "Exploit", icon: Lightning, accent: "text-blue-700" },
  { key: "subordinate", n: 3, title: "Subordinate", icon: ArrowsInLineVertical, accent: "text-blue-700" },
  { key: "elevate", n: 4, title: "Elevate", icon: TrendUp, accent: "text-blue-700" },
  { key: "repeat", n: 5, title: "Repeat", icon: ArrowsClockwise, accent: "text-amber-700" },
];

export default function TocBlueprint({ doc }) {
  const p = doc.payload || {};
  const history = p.version_history || [];
  return (
    <div className="space-y-3" data-testid="toc-blueprint">
      {history.length > 0 && (
        <div className="bg-white border border-amber-200 rounded-sm overflow-hidden" data-testid="toc-migration-history">
          <div className="px-5 py-3 border-b border-amber-100 flex items-center gap-2 bg-amber-50">
            <ClockCounterClockwise size={18} weight="duotone" className="text-amber-700" />
            <h3 className="text-sm font-semibold tracking-wide uppercase text-amber-800">Migration History — {history.length} archived</h3>
          </div>
          <div className="divide-y divide-slate-100">
            {[...history].reverse().map((v) => (
              <div key={v.version} className="p-5" data-testid={`toc-history-v${v.version}`}>
                <div className="flex items-center gap-2 mb-2">
                  <span className="w-7 h-7 rounded-sm bg-amber-600 text-white font-mono text-xs font-bold flex items-center justify-center">V{v.version}</span>
                  <span className="font-mono text-[11px] uppercase tracking-wide text-slate-400">Archived {(v.archived_at || "").slice(0, 10)}</span>
                </div>
                <p className="text-sm text-slate-800"><span className="font-semibold">Bottleneck:</span> {v.canvas?.identify || <span className="text-slate-300">—</span>}</p>
              </div>
            ))}
          </div>
        </div>
      )}
      {/* System drag callout */}
      {p.identify && (
        <div className="bg-amber-50 border border-amber-200 rounded-sm p-4 flex items-start gap-3" data-testid="toc-system-drag">
          <Warning size={20} weight="duotone" className="text-amber-700 shrink-0 mt-0.5" />
          <div>
            <p className="font-mono text-xs font-bold uppercase tracking-wide text-amber-800">System Drag — Active Constraint</p>
            <p className="mt-1 text-sm text-slate-800 whitespace-pre-wrap">{p.identify}</p>
          </div>
        </div>
      )}
      {STEPS.map((s) => (
        <div key={s.key} className="bg-white border border-slate-200 rounded-sm overflow-hidden" data-testid={`toc-block-${s.key}`}>
          <div className="px-5 py-3 border-b border-slate-100 flex items-center gap-3 bg-slate-50">
            <span className="w-7 h-7 rounded-sm bg-blue-700 text-white font-mono text-xs font-bold flex items-center justify-center">{s.n}</span>
            <s.icon size={18} weight="duotone" className={s.accent} />
            <h3 className="text-sm font-semibold tracking-wide uppercase text-slate-700">{s.title}</h3>
          </div>
          <div className="p-5">
            <p className="text-sm text-slate-800 whitespace-pre-wrap leading-relaxed">{p[s.key] || <span className="text-slate-300">—</span>}</p>
          </div>
        </div>
      ))}
    </div>
  );
}
